export const allRequirementSets = ['1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8', '1.9', '1.10', '1.11', '1.12', '1.13', '1.14', '1.15']

export default function officeApiGetSupportedRequirementSets(): string[] {
  const supportedRequirementSets: string[] = []

  allRequirementSets.some((requirementSet) => {
    if (Office.context.requirements.isSetSupported('Mailbox', requirementSet)) {
      supportedRequirementSets.push(requirementSet)
      return false
    } else {
      return true
    }
  })

  return supportedRequirementSets
}
